import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { Text } from '@naf/text';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { nafColor } from '@nafcore/theme';

export const Container = styled.div``;

export const InputContainer = styled.div`
  margin-top: ${spacing.space24};
  margin-bottom: ${spacing.space16};
`;

export const StyledButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    marginBottom: theme.spacing(8),
  },
}));

export const ErrorMessage = styled(Text)`
  color: ${nafColor.information.errorDark};
  margin-top: ${spacing.space4};
`;
